"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/History/Mobile/SessionsList.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _reactwaypoint = require('react-waypoint');
var _Spinner = require('web/components/Spinner'); var _Spinner2 = _interopRequireDefault(_Spinner);
var _SessionsListSection = require('./SessionsListSection'); var _SessionsListSection2 = _interopRequireDefault(_SessionsListSection);
var _MenuPicker = require('web/components/VideoRooms/Room/MenuPicker');




var _helpers = require('web/components/VideoRooms/Room/History/helpers');






















const initialState = () => ({
  todaySessions: [],
  yesterdaySessions: [],
  olderSessions: [],
  hasSessionsListDrained: false,
  isLoading: false,
  // SAFETY: timespanOptions is a non-empty module constant.
  currentTimespanOption: _helpers.timespanOptions[0].value,
  isTimespanMenuOpen: false,
})

const calcTotalSessionsCount = ({
  todaySessions, yesterdaySessions, olderSessions,
}) =>
  todaySessions.length + yesterdaySessions.length + olderSessions.length

// Handlers, the Waypoint and setState callbacks read the committed props and
// state (`this` in the class) through refs, so loads chained after an update
// see it, and loadSessions keeps one identity.
const MobileHistoryList = (props) => {
  const latestProps = _react.useRef.call(void 0, props)
  _react.useLayoutEffect.call(void 0, () => { latestProps.current = props })

  const [state, setState, latestState] = _helpers.useClassState.call(void 0, initialState)

  const openTimespanMenu = _react.useCallback.call(void 0, () => setState({ isTimespanMenuOpen: true }), [setState])
  const closeTimespanMenu = _react.useCallback.call(void 0, () => setState({ isTimespanMenuOpen: false }), [setState])

  const loadSessions = _react.useCallback.call(void 0, async () => {
    const { roomKey: RoomKey, loadSessionsList } = latestProps.current
    const current = latestState.current
    const {
      todaySessions, yesterdaySessions, olderSessions,
      isLoading, currentTimespanOption,
    } = current

    if (isLoading) return
    const totalSessionsCount = calcTotalSessionsCount(current)

    await new Promise(r => setState({ isLoading: true }, r))

    const StartedAfter = _helpers.calcStartedAfter.call(void 0, currentTimespanOption)

    const todayMoment = _moment2.default.call(void 0, ).startOf('day').format()
    const yesterdayMoment = _moment2.default.call(void 0, ).subtract(1, 'days').startOf('day').format()

    loadSessionsList({
      RoomKey,
      Skip: totalSessionsCount,
      Take: 10,
      StartedAfter,
    }).then(response => {
      // The JS destructured with an `= {}` default: a failed load (undefined)
      // stops here and leaves the spinner on.
      const RoomSessions = response === undefined ? undefined : response.RoomSessions
      if (!RoomSessions) return
      const [
        newTodaySessions, newYesterdaySessions, newOlderSessions,
      ] = RoomSessions.reduce((acc, s) => {
        // SAFETY: `new Date(undefined)` is an invalid date, which compares
        // false, as in JS.
        const startedAt = new Date(s.StartedAt )
        if (startedAt > new Date(todayMoment)) { return [acc[0].concat(s), acc[1], acc[2]] }
        if (startedAt > new Date(yesterdayMoment)) { return [acc[0], acc[1].concat(s), acc[2]] }
        return [acc[0], acc[1], acc[2].concat(s)]
      }, [[], [], []])

      setState({
        todaySessions: todaySessions.concat(newTodaySessions),
        yesterdaySessions: yesterdaySessions.concat(newYesterdaySessions),
        olderSessions: olderSessions.concat(newOlderSessions),
        hasSessionsListDrained: RoomSessions.length === 0,
        isLoading: false,
      })
    })
  }, [latestState, setState])

  const resetSessions = _react.useCallback.call(void 0, () =>
    setState({
      todaySessions: [], yesterdaySessions: [], olderSessions: [],
    }, loadSessions), [setState, loadSessions])

  const setTimespanOption = _react.useCallback.call(void 0, (currentTimespanOption) => {
    setState({ currentTimespanOption }, resetSessions)
  }, [setState, resetSessions])

  // componentDidMount
  _react.useLayoutEffect.call(void 0, () => { loadSessions() }, [loadSessions])

  const { onSessionPick } = props
  const {
    isLoading,
    currentTimespanOption,
    isTimespanMenuOpen,
    todaySessions, yesterdaySessions, olderSessions,
    hasSessionsListDrained,
  } = state

  const currentTimespanOptionLabel = _optionalChain([_helpers.timespanOptions, 'access', _ => _.find, 'call', _2 => _2(o =>
    o.value === currentTimespanOption,
  ), 'optionalAccess', _3 => _3.label])

  const totalSessionsCount = calcTotalSessionsCount(state)

  const shouldRenderWaypoint = totalSessionsCount > 0
    && !hasSessionsListDrained

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "meeting-room--mobile-history--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}
        , _react2.default.createElement('span', {
          onClick: openTimespanMenu,
          className: "meeting-room--mobile-history--headerbar-subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}

          ,  currentTimespanOptionLabel 
        )
        , _react2.default.createElement(_SessionsListSection2.default, {
          title: "Today",
          sessionsList: todaySessions,
          onSessionPick: onSessionPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
        )
        , _react2.default.createElement(_SessionsListSection2.default, {
          title: "Yesterday",
          sessionsList: yesterdaySessions,
          onSessionPick: onSessionPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}
        )
        , _react2.default.createElement(_SessionsListSection2.default, {
          title: "Older",
          sessionsList: olderSessions,
          onSessionPick: onSessionPick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
        )
        ,  shouldRenderWaypoint &&
          _react2.default.createElement(_reactwaypoint.Waypoint, { key: totalSessionsCount, onEnter: loadSessions, __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}} )
        
        ,  isLoading
          ? (
            _react2.default.createElement('div', { className: "meeting-room--mobile-history--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
              , _react2.default.createElement(_Spinner2.default, { color: "#6257c4", __self: this, __source: {fileName: _jsxFileName, lineNumber: 172}} )
            )
            )
          : (
            _react2.default.createElement('span', { className: "meeting-room--mobile-history--meetings-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
              ,  totalSessionsCount === 1
                ? '1 session'
                : `${totalSessionsCount} sessions`
              
            )
            )
        
        , _react2.default.createElement(_MenuPicker.MenuSelect, {
          title: "View history" ,
          isOpen: isTimespanMenuOpen,
          options: _helpers.timespanOptions,
          onChange: setTimespanOption,
          onClose: closeTimespanMenu,
          value: currentTimespanOption, __self: this, __source: {fileName: _jsxFileName, lineNumber: 184}}
        )
      )
    )
  )
}

exports. default = MobileHistoryList
